var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA41C",
    fillRule: "evenodd",
    d: "M6 0C2.6863 0 0 2.6863 0 6s2.6863 6 6 6 6-2.6863 6-6-2.6863-6-6-6Zm.5 2.6073C6.5 2.272 6.2761 2 6 2s-.5.272-.5.6073v4.7854C5.5 7.728 5.7239 8 6 8s.5-.272.5-.6073V2.6073ZM6.5 9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.bc043b30.svg";
export { ForwardRef as ReactComponent };